import {
    GET_SWITCH_NETWORK,
    GET_SWITCH_NETWORK_SUCCESS,
    GET_SWITCH_NETWORK_FAIL,
    GET_IPV4_SWITCH_NETWORK,
    GET_IPV4_SWITCH_NETWORK_SUCCESS,
    GET_IPV4_SWITCH_NETWORK_FAIL,
    IPV4_ADD_REQUEST,
    IPV4_ADD_SUCCESS,
    IPV4_ADD_FAIL,
    IPV4_DELETE_REQUEST,
    IPV4_DELETE_SUCCESS,
    IPV4_DELETE_FAIL,
    EDIT_IPV4_NETWORK,
    EDIT_IPV4_NETWORK_COMPLETE,
    EDIT_IPV4_NETWORK_FAILURE,
    GET_IPV6_SWITCH_NETWORK,
    GET_IPV6_SWITCH_NETWORK_SUCCESS,
    GET_IPV6_SWITCH_NETWORK_FAIL,
    IPV6_ADD_REQUEST,
    IPV6_ADD_FAIL,
    IPV6_ADD_SUCCESS,
    IPV6_DELETE_REQUEST,
    IPV6_DELETE_FAIL,
    IPV6_DELETE_SUCCESS,
    EDIT_IPV6_NETWORK,
    EDIT_IPV6_NETWORK_COMPLETE,
    EDIT_IPV6_NETWORK_FAILURE,
    RESET_IPV4_ADD,
    RESET_IPV4_DELETE,
    RESET_IPV4_EDIT,
    RESET_IPV6_ADD,
    RESET_IPV6_DELETE,
    RESET_IPV6_EDIT,
    GET_IPV6_SWITCH_MANAGEMENT,
    GET_IPV6_SWITCH_MANAGEMENT_SUCCESS,
    GET_IPV6_SWITCH_MANAGEMENT_FAIL,
    IPV6_MANAGEMENT_ADD_FAIL,
    IPV6_MANAGEMENT_SUCCESS,
    IPV6_MANAGEMENT_ADD_REQUEST,
    RESET_IPV6_MANAGEMENT_ADD,
    EDIT_IPV6_MANAGEMENT,
    EDIT_IPV6_MANAGEMENT_COMPLETE,
    EDIT_IPV6_MANAGEMENT_FAILURE,
    RESET_IPV6_MANAGEMENT_EDIT,
    IPV6_MANAGEMENT_DELETE_FAIL,
    IPV6_MANAGEMENT_DELETE_REQUEST,
    IPV6_MANAGEMENT_DELETE_SUCCESS,
    RESET_IPV6_MANAGEMENT_DELETE
} from '../../constants/switchConfiguration/networkConstants';
import { UI_STATES } from '../../constants/commonConstants';

/**
 * Reducer function for managing switch network data state.
 *
 * This reducer handles actions related to fetching switch network data.
 * It updates the state based on the dispatched action type and payload.
 *
 * @param {object} state - Current state of the switch network data.
 * @param {object} action - Action object that contains information about the action type and payload.
 * @return {object} - New state after applying the action.
 */
export const switchNetworkReducer = (state = { networkData: {} }, action) => {
    switch (action.type) {
        case GET_SWITCH_NETWORK:
            return {
                loading: true,
            };
        case GET_SWITCH_NETWORK_SUCCESS:
            return {
                loading: false,
                networkData: action.payload,
            };
        case GET_SWITCH_NETWORK_FAIL:
            return {
                loading: false,
                error: action.payload,
            };
        default:
            return state;
    }
};
export const ipv4NetworkReducer = (state = { ipv4NetworkData: {} }, action) => {
	switch (action.type) {
		case GET_IPV4_SWITCH_NETWORK:
			return {
				loading: true,
			};
		case GET_IPV4_SWITCH_NETWORK_SUCCESS:
			return {
				loading: false,
				ipv4NetworkData: action.payload,
			};
		case GET_IPV4_SWITCH_NETWORK_FAIL:
			return {
				loading: false,
				error: action.payload,
			};
		default:
			return state;
	}
};
export const ipv4AddReducer = (state = { data: {} }, action) => {
	switch (action.type) {
		case IPV4_ADD_REQUEST:
			return {
				...state,
				ipv4AddState: {
					...(state.ipv4AddState ?? {}),
					status: UI_STATES.LOADING,
				},
			};
		case IPV4_ADD_SUCCESS:
			return {
				...state,
				ipv4AddState: {
					...(state.ipv4AddState ?? {}),
					status: UI_STATES.SUCCESS,
					data: action.payload,
				},
			};
		case IPV4_ADD_FAIL:
			return {
				...state,
				ipv4AddState: {
					...(state.ipv4AddState ?? {}),
					status: UI_STATES.FAILURE,
					error: action.payload,
				},
			};
		case RESET_IPV4_ADD:
			return {
				...state,
				ipv4AddState: {
					loading: false,
					status: null,
					error: null,
					data: [],
				},
			};
		default:
			return state;
	}
};
export const ipv4DeleteReducer = (state = { data: {} }, action) => {
	switch (action.type) {
		case IPV4_DELETE_REQUEST:
			return {
				...state,
				ipv4DeleteState: {
					...(state.ipv4DeleteState ?? {}),
					status: UI_STATES.LOADING,
				},
			};
		case IPV4_DELETE_SUCCESS:
			return {
				...state,
				ipv4DeleteState: {
					...(state.ipv4DeleteState ?? {}),
					status: UI_STATES.SUCCESS,
					data: action.payload,
				},
			};
		case IPV4_DELETE_FAIL:
			return {
				...state,
				ipv4DeleteState: {
					...(state.ipv4DeleteState ?? {}),
					status: UI_STATES.FAILURE,
					error: action.payload,
				},
			};
		case RESET_IPV4_DELETE:
			return {
				...state,
				ipv4DeleteState: {
					loading: false,
					status: null,
					error: null,
					data: [],
				},
			};
		default:
			return state;
	}
};
export const editIpv4Reducer = (
	state = {
		loading: false,
		networkData: null,
		error: null,
	},
	action
) => {
	switch (action.type) {
		case EDIT_IPV4_NETWORK:
			return {
				...state,
				status: UI_STATES.loading,
				loading: true,
				error: null,
			};
		case EDIT_IPV4_NETWORK_COMPLETE:
			return {
				...state,
				status: UI_STATES.SUCCESS,
				loading: false,
				networkData: action.payload,
				error: null,
			};
		case EDIT_IPV4_NETWORK_FAILURE:
			return {
				...state,
				status: UI_STATES.FAILURE,
				loading: false,
				error: action.payload,
			};
		case RESET_IPV4_EDIT:
			return {
				...state,
				loading: false,
				status: null,
				networkData: null,
				error: null,
			};
		default:
			return state;
	}
};
export const ipv6NetworkReducer = (state = { ipv6NetworkData: {} }, action) => {
	switch (action.type) {
		case GET_IPV6_SWITCH_NETWORK:
			return {
				loading: true,
			};
		case GET_IPV6_SWITCH_NETWORK_SUCCESS:
			return {
				loading: false,
				ipv6NetworkData: action.payload,
			};
		case GET_IPV6_SWITCH_NETWORK_FAIL:
			return {
				loading: false,
				error: action.payload,
			};
		default:
			return state;
	}
};
export const ipv6AddReducer = (state = { data: {} }, action) => {
	switch (action.type) {
		case IPV6_ADD_REQUEST:
			return {
				...state,
				ipv6AddState: {
					...(state.ipv6AddState ?? {}),
					status: UI_STATES.LOADING,
				},
			};
		case IPV6_ADD_SUCCESS:
			return {
				...state,
				ipv6AddState: {
					...(state.ipv6AddState ?? {}),
					status: UI_STATES.SUCCESS,
					data: action.payload,
				},
			};
		case IPV6_ADD_FAIL:
			return {
				...state,
				ipv6AddState: {
					...(state.ipv6AddState ?? {}),
					status: UI_STATES.FAILURE,
					error: action.payload,
				},
			};
		case RESET_IPV6_ADD:
			return {
				...state,
				ipv6AddState: {
					loading: false,
					status: null,
					error: null,
					data: [],
				},
			};
		default:
			return state;
	}
};
export const ipv6DeleteReducer = (state = { data: {} }, action) => {
	switch (action.type) {
		case IPV6_DELETE_REQUEST:
			return {
				...state,
				ipv6DeleteState: {
					...(state.ipv6DeleteState ?? {}),
					status: UI_STATES.LOADING,
				},
			};
		case IPV6_DELETE_SUCCESS:
			return {
				...state,
				ipv6DeleteState: {
					...(state.ipv6DeleteState ?? {}),
					status: UI_STATES.SUCCESS,
					data: action.payload,
				},
			};
		case IPV6_DELETE_FAIL:
			return {
				...state,
				ipv6DeleteState: {
					...(state.ipv6DeleteState ?? {}),
					status: UI_STATES.FAILURE,
					error: action.payload,
				},
			};
		case RESET_IPV6_DELETE:
			return {
				...state,
				ipv6DeleteState: {
					loading: false,
					status: null,
					error: null,
					data: [],
				},
			};
		default:
			return state;
	}
};
export const editIpv6Reducer = (
	state = {
		loading: false,
		networkData: null,
		error: null,
	},
	action
) => {
	switch (action.type) {
		case EDIT_IPV6_NETWORK:
			return {
				...state,
				status: UI_STATES.loading,
				loading: true,
				error: null,
			};
		case EDIT_IPV6_NETWORK_COMPLETE:
			return {
				...state,
				status: UI_STATES.SUCCESS,
				loading: false,
				networkData: action.payload,
				error: null,
			};
		case EDIT_IPV6_NETWORK_FAILURE:
			return {
				...state,
				status: UI_STATES.FAILURE,
				loading: false,
				error: action.payload,
			};
		case RESET_IPV6_EDIT:
			return {
				...state,
				status: null,
				loading: false,
				networkData: null,
				error: null,
			};
		default:
			return state;
	}
};
export const ipv6ManagementReducer = (
	state = { ipv6ManagementData: {} },
	action
) => {
	switch (action.type) {
		case GET_IPV6_SWITCH_MANAGEMENT:
			return {
				loading: true,
			};
		case GET_IPV6_SWITCH_MANAGEMENT_SUCCESS:
			return {
				loading: false,
				ipv6ManagementData: action.payload,
			};
		case GET_IPV6_SWITCH_MANAGEMENT_FAIL:
			return {
				loading: false,
				error: action.payload,
			};
		default:
			return state;
	}
};
export const ipv6ManagementAddReducer = (state = { data: {} }, action) => {
	switch (action.type) {
		case IPV6_MANAGEMENT_ADD_REQUEST:
			return {
				...state,
				ipv6ManagementAddState: {
					...(state.ipv6ManagementAddState ?? {}),
					status: UI_STATES.LOADING,
				},
			};
		case IPV6_MANAGEMENT_SUCCESS:
			return {
				...state,
				ipv6ManagementAddState: {
					...(state.ipv6ManagementAddState ?? {}),
					status: UI_STATES.SUCCESS,
					data: action.payload,
				},
			};
		case IPV6_MANAGEMENT_ADD_FAIL:
			return {
				...state,
				ipv6ManagementAddState: {
					...(state.ipv6ManagementAddState ?? {}),
					status: UI_STATES.FAILURE,
					error: action.payload,
				},
			};
		case RESET_IPV6_MANAGEMENT_ADD:
			return {
				...state,
				ipv6ManagementAddState: {
					loading: false,
					status: null,
					error: null,
					data: [],
				},
			};
		default:
			return state;
	}
};
export const editIpv6ManagementReducer = (
	state = {
		loading: false,
		ipv6ManagementData: null,
		error: null,
	},
	action
) => {
	switch (action.type) {
		case EDIT_IPV6_MANAGEMENT:
			return {
				...state,
				status: UI_STATES.loading,
				loading: true,
				error: null,
			};
		case EDIT_IPV6_MANAGEMENT_COMPLETE:
			return {
				...state,
				status: UI_STATES.SUCCESS,
				loading: false,
				ipv6ManagementData: action.payload,
				error: null,
			};
		case EDIT_IPV6_MANAGEMENT_FAILURE:
			return {
				...state,
				status: UI_STATES.FAILURE,
				loading: false,
				error: action.payload,
			};
		case RESET_IPV6_MANAGEMENT_EDIT:
			return {
				...state,
				status: null,
				loading: false,
				ipv6ManagementData: null,
				error: null,
			};
		default:
			return state;
	}
};
export const ipv6ManagementDeleteReducer = (state = { data: {} }, action) => {
	switch (action.type) {
		case IPV6_MANAGEMENT_DELETE_REQUEST:
			return {
				...state,
				ipv6ManagementDeleteState: {
					...(state.ipv6ManagementDeleteState ?? {}),
					status: UI_STATES.LOADING,
				},
			};
		case IPV6_MANAGEMENT_DELETE_SUCCESS:
			return {
				...state,
				ipv6ManagementDeleteState: {
					...(state.ipv6ManagementDeleteState ?? {}),
					status: UI_STATES.SUCCESS,
					data: action.payload,
				},
			};
		case IPV6_MANAGEMENT_DELETE_FAIL:
			return {
				...state,
				ipv6ManagementDeleteState: {
					...(state.ipv6ManagementDeleteState ?? {}),
					status: UI_STATES.FAILURE,
					error: action.payload,
				},
			};
		case RESET_IPV6_MANAGEMENT_DELETE:
			return {
				...state,
				ipv6ManagementDeleteState: {
					loading: false,
					status: null,
					error: null,
					data: [],
				},
			};
		default:
			return state;
	}
};
